"use client";

import { SelectField } from "@repo/ui/form-fields";
import { useFieldBinding } from "@/shared/forms/connected-fields";

export interface BookingAdvanceLimitValue {
  value: number;
  unit: "d" | "wk";
}

const ADVANCE_LIMIT_OPTIONS: { label: string; value: number; unit: "d" | "wk" }[] = [
  { label: "12 weeks", value: 12, unit: "wk" },
  { label: "16 weeks", value: 16, unit: "wk" },
  { label: "20 weeks", value: 20, unit: "wk" },
  { label: "24 weeks", value: 24, unit: "wk" },
  { label: "28 weeks", value: 28, unit: "wk" },
  { label: "32 weeks", value: 32, unit: "wk" },
  { label: "36 weeks", value: 36, unit: "wk" },
  { label: "40 weeks", value: 40, unit: "wk" },
  { label: "44 weeks", value: 44, unit: "wk" },
  { label: "48 weeks", value: 48, unit: "wk" },
  { label: "52 weeks", value: 52, unit: "wk" },
];

function encode(d: BookingAdvanceLimitValue): string {
  return `${d.value}-${d.unit}`;
}

function decode(key: string): BookingAdvanceLimitValue {
  const [val, unit] = key.split("-");
  return { value: Number(val), unit: unit as "d" | "wk" };
}

export interface BookingAdvanceLimitFieldProps {
  label?: string;
  description?: string;
  disabled?: boolean;
}

export function BookingAdvanceLimitField({ label, description, disabled }: BookingAdvanceLimitFieldProps) {
  const { value, onChange, onBlur, errors, isTouched } = useFieldBinding<BookingAdvanceLimitValue>();

  return (
    <SelectField
      value={encode(value)}
      onChange={(v) => {
        if (v) onChange(decode(v));
        onBlur();
      }}
      onBlur={onBlur}
      errors={errors}
      isTouched={isTouched}
      label={label}
      description={description}
      options={ADVANCE_LIMIT_OPTIONS.map((o) => ({ value: encode(o), label: o.label }))}
      disabled={disabled}
    />
  );
}
